import Button from '@components/Button';
import Column from '@components/Column';
import Text from '@components/Text';
import ModalContainer from '@modals/ModalContainer';
import { Modal } from '@stackflow/plugin-basic-ui';
import { ActivityComponentType } from '@stackflow/react';
import { openExternalLink } from '@utils/nativeUtils';
import { useTranslation } from 'react-i18next';

interface Params {
    storeUrl: string;
}

declare module '@stackflow/config' {
    interface Register {
        ForceUpdateModal: Params;
    }
}

const ForceUpdateModal: ActivityComponentType<'ForceUpdateModal'> = ({ params }) => {
    const { storeUrl } = params;
    const { t } = useTranslation('common');
    return (
        <Modal onOutsideClick={(e) => {
            e.preventDefault();
            e.stopPropagation();
        }}>
            <ModalContainer>
                <Column fullWidth spacing={24} align='center'>
                    <Text size='xl'>{t('forceUpdate.title')}</Text>
                    <Button onClick={() => openExternalLink(storeUrl)}>
                        {t('forceUpdate.goToStore')}
                    </Button>
                </Column>
            </ModalContainer>
        </Modal>
    );
};

export default ForceUpdateModal;
